import { get } from 'lodash';

export const getExports = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.savedExports');
export const getLoading = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.loading');
export const getErrors = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.error');
export const getDeleteSuccessful = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.deleteSuccessful');



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/exportlist/selectors.js